import { GpsType } from '../types/device';

export const GPS_TYPE_TRACKING = 'Rastreo';
export const GPS_TYPE_OBD = 'OBD';
export const GPS_TYPE_CAMERA = 'Cámara';

export const GPS_TYPE_OPTIONS = [
  {
    id: GpsType.tracking,
    label: GPS_TYPE_TRACKING,
  },
  {
    id: GpsType.obd,
    label: GPS_TYPE_OBD,
  },
  {
    id: GpsType.camera,
    label: GPS_TYPE_CAMERA,
  },
];

export const GPS_TYPE_LABELS = {
  [GpsType.tracking]: GPS_TYPE_TRACKING,
  [GpsType.obd]: GPS_TYPE_OBD,
  [GpsType.camera]: GPS_TYPE_CAMERA,
};


export const CHANNELS_OPTIONS = [
  {
    id: 2,
    label: "2 Canales",
  },
  {
    id: 3,
    label: "3 Canales",
  },
];